import { render, staticRenderFns } from "./CorePage.vue?vue&type=template&id=238aac58&"
import script from "./CorePage.vue?vue&type=script&lang=js&"
export * from "./CorePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports